<div  [style.background]="cover ? 'url('+cover+')' : ''"  class="wrapper">
 
<ul *ngIf="init" class="countdown">
  <li class="days">
    <div class="number">{{days < 10 ? '0'+days : days}}</div>
    <div class="label">{{ isEnglish ? 'Days' : 'Днів'}}</div>
  </li>
  <li class="hours">
    <div class="number">{{hours < 10 ? '0'+hours : hours}}</div>
    <div class="label">{{ isEnglish ? 'Hours' : 'Годин'}}</div>
  </li>
  <li class="minutes">
    <div class="number">{{minutes < 10 ? '0'+minutes : minutes}}</div>
    <div class="label">{{ isEnglish ? 'Minutes' : 'Хвилин'}}</div>
  </li>
  <li class="seconds">
    <div class="number">{{seconds < 10 ? '0'+seconds : seconds}}</div>
    <div class="label">{{ isEnglish ? 'Seconds' : 'Секунд'}}</div>
  </li>
</ul>

</div>
